import { toast } from 'react-toastify';

//===============================
// Colors
//===============================

export const getColor = (name, dom = document.documentElement) => {
  return getComputedStyle(dom).getPropertyValue(`--falcon-${name}`).trim();
};

//===============================
// Helpers
//===============================

export const capitalize = str =>
  (str.charAt(0).toUpperCase() + str.slice(1).toLowerCase()).replace(/-/g, ' ');

export const preventKeyPress = e => {
  e.key === 'Enter' && e.preventDefault();
};

export const renderErrorToast = message => {
  toast.error(
    message ?? 'Something went wrong. Please contact the support team.'
  );
};

export const convertArrayToCommaString = array => {
  return array && array.length > 0 ? array.join(', ') : '';
};

export const translateToMetaDataKey = key => {
  switch (key) {
    case 'companies':
      return 'companyName';
    case 'functions':
      return 'function';
    case 'performance_claims':
      return 'claims';
    case 'applications':
      return 'applications';
    case 'sustainability_claims':
      return 'sustainabilityClaims';
    case 'chemicalgroups':
      return 'chemicalComposition';
    case 'certifications':
      return 'certifications';
    case 'regions':
      return 'regionsEffective';
    case 'countries':
      return 'countriesEffective';
    case 'segments':
      return 'segment';
  }
};

/**
 *
 * @returns a promise that resolves or rejects when a 'confirm' or 'cancel' event is emmited. Make sure either is emmited to avoid memory leaks.
 */
export const waitForConfirm = () =>
  new Promise((resolve, reject) => {
    const successHandler = e => {
      e.currentTarget?.removeEventListener('cancel', cancelHandler);
      resolve('');
    };
    const cancelHandler = e => {
      e.currentTarget?.removeEventListener('confirm', successHandler);
      reject('');
    };
    window.addEventListener('confirm', successHandler, { once: true });
    window.addEventListener('cancel', cancelHandler, { once: true });
  });
